import { put, call } from 'redux-saga/effects';
import { 
  patientService,
  updatePatientService, 
  fetchAllPatientsService, 
  fetchPatientService,
  fetchPatientsByPatientNameService,
  fetchPatientByPhoneService,
  fetchPatientsByAttenderNameService, 
  matchingDonorsService,
  matchDonorbyPhoneService,
  saveMatchingDonorService, 
  verifyPatientService } from '../services/patientService';

import * as types from '../actions'

export function* patientSaga(payload) {
  try {
    const response = yield call(patientService, payload);
    yield put({ type: types.PATIENT_SUBMIT_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.PATIENT_SUBMIT_ERROR, error })
  }
}

export function* fetchAllPatientsSaga(payload){
  try {
    const response = yield call(fetchAllPatientsService, payload);
    yield put({ type: types.ALL_PATIENT_FETCH_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.ALL_PATIENT_FETCH_ERROR, error })
  }
}

export function* fetchPatientSaga(payload) {
  try {
    const response = yield call(fetchPatientService, payload);
    yield put({ type: types.PATIENT_FETCH_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.PATIENT_FETCH_ERROR, error })
  }
}

export function* fetchPatientsByPatientNameSaga(payload) {
  try {
    const response = yield call(fetchPatientsByPatientNameService, payload);
    yield put({ type: types.FETCH_BY_PATIENT_NAME_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.FETCH_BY_PATIENT_NAME_ERROR, error })
  }
}

export function* fetchPatientsByAttenderNameSaga(payload) {
  try {
    const response = yield call(fetchPatientsByAttenderNameService, payload);
    yield put({ type: types.FETCH_BY_ATTENDER_NAME_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.FETCH_BY_ATTENDER_NAME_ERROR, error })
  }
}

export function* fetchPatientByPhoneSaga(payload) {
  try {
    const response = yield call(fetchPatientByPhoneService, payload);
    yield put({ type: types.FETCH_BY_PATIENT_PHONE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.FETCH_BY_PATIENT_PHONE_ERROR, error })
  }
}

export function* verifyPatientSaga(payload) {
  try {
    const response = yield call(verifyPatientService, payload);
    yield put({ type: types.PATIENT_VERIFY_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.PATIENT_VERIFY_ERROR, error })
  }
}

export function* matchingDonorsSaga(payload) {
  try {
    const response = yield call(matchingDonorsService, payload);
    yield put({ type: types.MATCH_DONORS_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.MATCH_DONORS_ERROR, error })
  }
}

export function* matchDonorPhoneSaga(payload) {
  try {
    const response = yield call(matchDonorbyPhoneService, payload);
    yield put({ type: types.MATCH_DONOR_PHONE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.MATCH_DONOR_PHONE_ERROR, error })
  }
}

export function* saveMatchingDonorSaga(payload) {
  try {
    const response = yield call(saveMatchingDonorService, payload);
    yield put({ type: types.SAVE_MATCHING_DONOR_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.SAVE_MATCHING_DONOR_ERROR, error })
  }
}

export function* updatePatientSaga(payload) {
  try {
    const response = yield call(updatePatientService, payload);
    yield put({ type: types.PATIENT_UPDATE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.PATIENT_UPDATE_ERROR, error })
  }
}